export default __webpack_public_path__ + "assets/49632bd3de93a632.jpg";